import { render, staticRenderFns } from "./wiki-map-demo.vue?vue&type=template&id=173aa993&"
import script from "./wiki-map-demo.vue?vue&type=script&lang=ts&"
export * from "./wiki-map-demo.vue?vue&type=script&lang=ts&"
import style0 from "./wiki-map-demo.vue?vue&type=style&index=0&id=173aa993&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports